import React from "react";

import "./Message.css";
const ErrorPage = () => {
  return (
    <div className="message-area text-center">
      <div className="message-content ">
        <h1 className="text-danger text-capitalize">404</h1>
        <h2 className="text-danger text-uppercase error-message">
          Page not found
        </h2>
        <p className="text-warning">
          The requested url was not found. <br />
          As a result you landed on custom error page
        </p>
      </div>
    </div>
  );
};

export default ErrorPage;
